(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wistgo-elise-reveal"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wistgo-watch-reveal')) {
  customElements.define('wistgo-watch-reveal', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const range = this.querySelector('input');
      range.addEventListener('input', () => {
        this.style.setProperty('--reveal', range.value + '%');
        range.setAttribute('aria-valuetext', range.value + '% ' + range.dataset.before + ', ' + (100 - Number(range.value)) + '% ' + range.dataset.after);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wistgo-watch-reveal"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wistgo-watch-reveal')) {
  customElements.define('wistgo-watch-reveal', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const range = this.querySelector('input');
      range.addEventListener('input', () => {
        this.style.setProperty('--reveal', range.value + '%');
        range.setAttribute('aria-valuetext', range.value + '% ' + range.dataset.before + ', ' + (100 - Number(range.value)) + '% ' + range.dataset.after);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
